import React from 'react';
import { Paper, Typography, Box, useTheme } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const COLORS = ['#1565c0', '#2e7d32', '#ed6c02', '#9c27b0', '#d32f2f', '#0288d1', '#5d4037', '#455a64'];

const OrdersStatusChart = ({ data, title, emptyLabel }) => {
  const theme = useTheme();
  const rows = Array.isArray(data) ? data.map((d) => ({ name: d.label, value: d.value })) : [];
  const hasData = rows.some((r) => r.value > 0);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        height: '100%',
        minHeight: 300,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>
      {!hasData ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 260, color: 'text.secondary' }}>
          {emptyLabel}
        </Box>
      ) : (
        <ResponsiveContainer width="100%" height={260}>
          <PieChart margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
            <Pie
              data={rows}
              dataKey="value"
              nameKey="name"
              cx="42%"
              cy="50%"
              innerRadius={52}
              outerRadius={82}
              paddingAngle={2}
            >
              {rows.map((entry, index) => (
                <Cell key={`${entry.name}-${index}`} fill={COLORS[index % COLORS.length]} stroke={theme.palette.background.paper} />
              ))}
            </Pie>
            <Tooltip formatter={(v) => [v, '']} />
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="middle"
              iconType="circle"
              wrapperStyle={{ fontSize: 12, lineHeight: '1.35' }}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default OrdersStatusChart;
